import Layout from '@/layout';

export default {
  weight: 5,
  path: '/order',
  component: Layout,
  redirect: '/order/orderList',
  name: 'order',
  meta: { title: '订单管理', icon: 'el-icon-s-finance' },
  children: [
    {
      path: 'orderList',
      name: 'orderList',
      component: () => import('@/views/order/orderList'),
      meta: { title: '订单', icon: 'el-icon-s-data' },
    },
    {
      path: 'orderDetails',
      name: 'orderDetails',
      component: () => import('@/views/order/orderDetails'),
      meta: { title: '订单详情', icon: 'el-icon-s-data', activeMenu: '/order/orderList' },
      hidden: true,
    },
    {
      path: 'tryOrderList',
      name: 'tryOrderList',
      component: () => import('@/views/order/tryOrderList'),
      meta: { title: '试戴订单', icon: 'el-icon-s-data' },
    },
    {
      path: 'tryOrderBack',
      name: 'tryOrderBack',
      component: () => import('@/views/order/tryOrderBack'),
      meta: { title: '试戴退回', icon: 'el-icon-s-data' },
    },
    {
      path: 'tryOrderBackDetails',
      name: 'tryOrderBackDetails',
      component: () => import('@/views/order/tryOrderBackDetails'),
      meta: { title: '试戴订单详情', icon: 'el-icon-s-data', activeMenu: '/order/tryOrderList' },
      hidden: true,
    },
  ],
};
